export enum DataSelectionFilterType {
  TOKEN = 'token',
  DATE = 'date',
}
